<mat-card appearance="outlined" class="sign-off-employee-card hdmui-m-5 hdmui-p-0">
    <div class="hdmui-content">
        <div class="sign-off-employee-card__headers">
            <h1 class="hdmui-font-serif hdmui-m-0">
                {{ machine.machineName }}
            </h1>
            <h1 class="hdmui-font-bold hdmui-m-0">
                {{ machine.machineId }}
            </h1>
        </div>
        <div class="sign-off-employee-card__buttons">
            <form [formGroup]="formGroup">
                <mat-radio-group
                    formControlName="assistantsSignOff"
                    [name]="'deputy' + machine.machineId"
                    (change)="setSelectState($event)"
                >
                    <mat-radio-button
                        class="hdmui-my-4 hdmui-me-4"
                        [name]="'deputy' + machine.machineId"
                        [value]="LEAVE"
                        [attr.data-testid]="'sign-off-employees-card-radio-button-leave-' + machine.machineId"
                        >{{ 'DC.SIGN_OFF_DIALOG.EMPLOYEES.CARD.LEAVE' | translate }}
                    </mat-radio-button>
                    <mat-radio-button
                        class="hdmui-my-4 hdmui-me-4"
                        [name]="'deputy' + machine.machineId"
                        [value]="STAY"
                        [disabled]="(machine.signedOnUsers | filterAvailableCaptains).length === 0"
                        [attr.data-testid]="'sign-off-employees-card-radio-button-stay-' + machine.machineId"
                    >
                        {{ 'DC.SIGN_OFF_DIALOG.EMPLOYEES.CARD.STAY' | translate }}
                    </mat-radio-button>
                </mat-radio-group>
                @if (formGroup.controls.assistantsSignOff.value === STAY) {
                    <mat-form-field>
                        <mat-label>{{ 'DC.USER.DEPUTY' | translate }}</mat-label>
                        <mat-select
                            formControlName="newCaptain"
                            [hideSingleSelectionIndicator]="true"
                            [attr.data-testid]="'ask-for-booking-code-dialog-select-deputy-' + machine.machineId"
                        >
                            @for (option of machine.signedOnUsers | filterAvailableCaptains; track option.userId) {
                                @if (option.userId !== operatorId) {
                                    <mat-option
                                        [value]="option.userId"
                                        [attr.data-testid]="
                                            'ask-for-booking-code-dialog-option-deputy-' + machine.machineId
                                        "
                                        >{{ option.userId }}
                                    </mat-option>
                                }
                            }
                        </mat-select>
                    </mat-form-field>
                }
            </form>
        </div>
    </div>
</mat-card>
